export default {
    props: {
        src: {
            type: String,
            require: true,
        },
    },
    
    data() {
        return {
            playing: false,
            
            duration: 0,
            durationSeconds: "00",
            durationMinutes: "00",
            
            percentage: 0,

            currentTime: 0,
            curSeconds: "00",
            curMinutes: "00",

            muted: true,
        }
    },

    methods: {
        togglePlaying() {
            this.playing = !this.playing;
            if (this.playing) {
                this.$refs.player.play();
            } else {
                this.$refs.player.pause();
            }
        },

        loadDataHandler(ev) {
            this.duration = this.$refs.player.duration;
        
            this.durationSeconds = Math.round(this.duration % 60);
            this.durationMinutes = Math.round(this.duration / 60);
        
            this.durationSeconds = this.durationSeconds < 10 ? `0${this.durationSeconds}` : this.durationSeconds;
            this.durationMinutes = this.durationMinutes < 10 ? `0${this.durationMinutes}` : this.durationMinutes;
        },

        timeUpdateHandler(ev) {
            this.currentTime = this.$refs.player.currentTime;
            this.curSeconds = Math.round(this.currentTime % 60);
            this.curMinutes = Math.round(this.currentTime / 60);
        
            this.curSeconds = this.curSeconds < 10 ? `0${this.curSeconds}` : this.curSeconds;
            this.curMinutes = this.curMinutes < 10 ? `0${this.curMinutes}` : this.curMinutes;
        
            this.percentage = (this.currentTime / this.duration) * 100;
            
            if (this.curSeconds === this.durationSeconds && this.curMinutes === this.durationMinutes) {
                this.playing = false;
            }
        },
    },

    mounted() {
        this.$refs.player.addEventListener("loadeddata", this.loadDataHandler);
        this.$refs.player.addEventListener("timeupdate", this.timeUpdateHandler);
    },

    beforeUnmount() {
        this.$refs.player.removeEventListener("loadeddata", this.loadDataHandler);
        this.$refs.player.removeEventListener("timeupdate", this.timeUpdateHandler);
    }
}